import React, { FC, useState } from 'react';
import styles from './AppLayout.module.scss';
import Header from '../Header';
import Sidebar from '../Sidebar';
import ImpersonationBanner from '../ImpersonationBanner';
import { Outlet, useLocation } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from '@/components/Loading';
import { SupportWidget } from '../Chatbot';

/* istanbul ignore file */

const onRedirecting = (): JSX.Element => <Loading />;

const AppLayout: FC = withAuthenticationRequired(
  ({ children }) => {
    const [isOpen, setOpen] = useState(true);
    const { pathname } = useLocation();
    const isWorkbench = pathname.startsWith('/workbench/');

    const toggleSidebar = (): void => {
      setOpen(!isOpen);
    };

    return (
      <div className={styles.layout}>
        <ImpersonationBanner />
        <Sidebar toggleSidebar={toggleSidebar} isOpen={isOpen} />
        <main className={isOpen ? styles.mainContent : styles.mainContentClosed}>
          <Header />
          <section className={`${styles.content} ${isWorkbench ? styles.contentNoScroll : ''}`}>
            <Outlet />
          </section>
        </main>
        <SupportWidget
          apiBase={process.env.REACT_APP_CHATBOT_API_BASE}
          brandColor="#dc2626"
          hideLauncher={isWorkbench}
        />
      </div>
    );
  },
  {
    onRedirecting,
  },
);

export default AppLayout;
